<template>
  <v-img class="align-center d-inline-block vertical-align"
         :class="{'cursor-pointer': showDocument}"
         @click.stop.prevent="openDocument()"
         :height="height" :width="width" :max-width="width"
         :src="imgSrc"/>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'BqaCertificateIcon',
  props: {
    driver: {
      type: Object,
      default: null,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    responsive: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    height() {
      if (this.responsive) {
        return null;
      }
      return this.small ? 24 : 42;
    },
    width() {
      if (this.responsive) {
        return null;
      }
      return this.small ? 29 : 50;
    },
    showDocument() {
      return !!_.get(this.driver, 'bqaCertification.documentUri', false);
    },
    imgSrc() {
      let imgSrc = '/static/BQA-not-certified.png';
      if (_.get(this.driver, 'bqaCertification.verified', false) ||
          _.get(this.driver, 'bqaVerified', false)) {
        imgSrc = '/static/BQA-verified.png';
      } else if (_.get(this.driver, 'bqaCertification.expires', false) ||
          _.get(this.driver, 'bqaExpires', false)) {
        imgSrc = '/static/BQA-provided.png';
      }

      return imgSrc;
    },
  },
  methods: {
    openDocument() {
      if (this.showDocument) {
        this.$store.dispatch('lightbox/show', this.driver.bqaCertification.documentUri);
      }
    },
  },
};
</script>

<style scoped>
  .vertical-align {
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/BqaCertificateIcon.vue